import './style.scss';

document.querySelectorAll(".about-content-award").forEach(
  div=>{
    var front = div.firstElementChild;
    var back = div.children[div.children.length-1];
    var onFront = true;
    var hasTouch = false;
    div.addEventListener("click", 
      ()=>{
        front.style.opacity=(onFront) ? 0 : 1;
        back.style.opacity=(onFront) ? 1 : 0;
        onFront=!onFront;
      }
    );
    div.addEventListener("touchstart", ()=>{
      hasTouch = true;
    });
    div.addEventListener("touchmove", ()=>{});
    div.addEventListener("mouseover", ()=>{
        if (hasTouch) return;
        front.style.opacity=0;
        back.style.opacity=1;
        onFront=false;
    });
    div.addEventListener("mouseout", ()=>{
        if (hasTouch) return;
        front.style.opacity=1;
        back.style.opacity=0;
        onFront=true;
    });
  }
);
